/**
 * External dependencies
 */
import { Reducer } from 'redux';

/**
 * Internal dependencies
 */
import { setEventsLoading } from '@/store/actions';
import initialState from '../../initialState';
import isAction from '../../isAction';

const loading: Reducer<boolean> = (
	state = initialState.events.loading,
	action
) => (isAction(action, setEventsLoading) ? action.payload : state);

export default loading;
